export const WORKLINE_STATUS_COUNT_VIEWS = Object.freeze({
    ORGANIZATION: "organization",
    FILTER: "filter",
    TEAM: "team",
});
